import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import { api, trackEvent } from "../../lib/api";

const MESSAGE_BY_PATH = [
  { match: "/affiliate", msg: "Hi Ekavrix Team, I would like to discuss an affiliate or strategic partnership." },
  { match: "/ventures/ekavrix-cafe", msg: "Hi Ekavrix Team, I would like to receive updates regarding your upcoming cafe venture." },
];
const DEFAULT_MSG = "Hi Ekavrix Team, I would like to discuss a business opportunity.";

export const WhatsAppFloat = () => {
  const [number, setNumber] = useState(null);
  const { pathname } = useLocation();

  useEffect(() => {
    api.get("/content/config").then((r) => setNumber(r.data?.whatsapp_number || null)).catch(() => {});
  }, []);

  if (!number || pathname.startsWith("/admin")) return null;

  const msg = (MESSAGE_BY_PATH.find((m) => pathname.startsWith(m.match)) || {}).msg || DEFAULT_MSG;
  const href = `https://wa.me/${number}?text=${encodeURIComponent(msg)}`;

  return (
    <a href={href} target="_blank" rel="noopener noreferrer" data-testid="whatsapp-float" aria-label="Chat with Ekavrix on WhatsApp"
      onClick={() => trackEvent("whatsapp_click", { from: pathname })}
      className="fixed bottom-6 right-6 z-40 flex h-14 w-14 items-center justify-center rounded-full bg-teal text-midnight shadow-[0_10px_35px_rgba(32,184,173,0.4)] transition-transform duration-300 hover:scale-110 sm:bottom-8 sm:right-8">
      <MessageCircle size={24} />
    </a>
  );
};
